import commonApi from '@/api/common';
import _get from 'lodash/get';
import moment from 'moment';
import { VueCookieNext } from 'vue-cookie-next';
import { privacyUpdate } from '@shining3d/xl-login';

import store from '../../store';
/**
 * $convertUTCDateToLocalDate 地区日期差格式化转换 接收一个国际时间参数 需要vuex存在时区列表countryList 需要moment插件
 * $doLang 语言转换 zh转zh_cn，默认zh_cn
 * $rdoLang lang转换 zh_cn转zh 默认$lang
 * $lang 获取当前语言 获取cookie中lang字段
 * $formErr msg报错处理
 *   接收res, form, type = 'form'
 *   res字符串直接msg提示 type不为from则msg分别提示
 * $setLocalStorage 本地存储
 * $getLocalStorage 获取本地存储
 * $removeLocalStorage 删除本地存储
 * $checkPerm 需要vuex存在 permsList权限点列表 查询权限点是否存在（list/string），权限点列表为vuex permsList
 * $hasOnePerm 单个权限点是否存在，接收两个参数 list perm
 * $getCdnUrl  地址拼接 需要vuex存在 global.cdnUr、global.cloud
 * $getInfo 获取个人信息
 * $getFactoryList 获取当前账号归属机构列表 接收 type = { onlySelf: true, showMembers: true, lang: $rdoLang() }
 * $logouts 退出登录 接收退出后跳转地址
 * $getSettingList 枚举查询 接收{ type lang }
 * $getPhoneArea 获取国家码初始值 接收国家缩写，默认cookie中cc
 * $getPermList 获取当前账号权限列表 接收type类型
 */
import {
	$checkPerm,
	$doLang,
	$formErr,
	$getCdnUrl,
	$hasOnePerm,
	$lang,
	$rdoLang,
} from '@shining3d/common-module/utils/index.js';
import {
	$getFactoryList,
	$getInfo,
	$getPermList,
	$getSettingList
} from '@shining3d/info-component/index.js';
// const { $t } = useLang( '@shining3d/app' );

const cc = VueCookieNext.getCookie( 'cc' ) || 'CN';

function $setLocalStorage( type, val ) {
	localStorage.setItem(
		( window.app.entryName || 'dental' ) + '-' + type,
		JSON.stringify( val )
	);
}

function $removeLocalStorage( type ) {
	localStorage.removeItem( window.app.entryName + '-' + type );
	localStorage.removeItem( type );
}

// 获取本地存储
function $getLocalStorage( type ) {
	if ( !type ) {
		return '';
	}
	let objtxt = localStorage.getItem( window.app.entryName + '-' + type );
	try {
		objtxt = JSON.parse( objtxt );
	} catch ( error ) {
		console.log( error );
	}
	return objtxt;
}

// 地区日期差格式化转换 需要vuex存在时区列表countryList 需要moment插件
function $convertUTCDateToLocalDate( sd, format = 'YYYY-MM-DD HH:mm:ss' ) {
	if ( !sd || Object.keys( sd ).length < 1 ) {
		return '';
	}
	// TODO 时区差需要地区数据支撑
	let utcOffset = 0;
	const zones = ( $getLocalStorage( 'countryList' ) || []).find(( val ) => cc.toUpperCase() === val.id );
	// store.state.countryList.find(( val ) => cc.toUpperCase() === val.id );
	if ( zones ) {
		try {
			utcOffset = JSON.parse( zones.timezones )[ 0 ].utcOffset;
		} catch ( error ) {
			console.log( error );
		}
	}
	return moment.utc( sd ).utcOffset( utcOffset ).
		format( format );
}

// 图片引入
const $importImg = ( imgPath ) => new URL( `../image/${imgPath}`, import.meta.url ).href;

// 获取当前加入的归属机构列表(默认为已加入状态)
function $factoryList( type = 'active' ) {
	return store.state.factoryObjList ? store.state.factoryObjList.filter(( val ) => val.memberStatus === type ) : [];
}

// 获取国家，国家码列表
async function $getCountry() {
	const res = await commonApi.getCountry();
	if ( res.status === 'success' ) {
		const countryList = res.result.map(( val ) => ({
			...val,
			value: val.id,
			label: val.name === val.native ? val.name : val.name + ' ' + val.native,
		}));
		const phoneAreaList = [];
		res.result.forEach(( val ) => {
			if ( val.phone.split( ',' ).length === 1 ) {
				phoneAreaList.push({
					label:
						val.name === val.native ? `+${val.phone} ${val.name}` : `+${val.phone} ${val.name} ${val.native}`,
					value: `${val.phone}-${val.id}`,
				});
			} else {
				val.phone.split( ',' ).map(( item ) => {
					phoneAreaList.push({
						label:
							val.name === val.native ? `+${item} ${val.name}` : `+${item} ${val.name} ${val.native}`,
						value: `${item}-${val.id}`,
					});
				});
			}
		});
		localStorage.setItem( 'areaCodeOptions', JSON.stringify([...phoneAreaList]));
		localStorage.setItem( 'countryList', JSON.stringify([...countryList]));
		store.commit( 'setPhone', [...phoneAreaList] || []);
		store.commit( 'setCountry', [...countryList] || []);
		return [...res.result];
	} else {
		store.commit( 'setPhone', []);
		store.commit( 'setCountry', []);
		return [];
	}
}

// 设置当前语言
async function $setLang( val ) {
	await VueCookieNext.setCookie( 'lang', val );
	window.location.reload();
}

// 设置当前选择的机构
function $setFactory( val ) {
	$setLocalStorage( 'currentOrganization', val );
	window.location.reload();
}

// 退出登录
async function $logout( redirectTo ) {
	console.log( '$exitBySearch ： 退出登录' );
	// 登出时使后端token失效
	const userId = $getLocalStorage( 'userInfo' )?.userID;
	await commonApi.userLogout({ logoutType: 'openCloudSite', userId });
	VueCookieNext.removeCookie( 'token' );
	VueCookieNext.removeCookie( 'user_id' );
	VueCookieNext.removeCookie( 'uTitle' );
	$removeLocalStorage( 'userInfo' );
	$removeLocalStorage( 'currentOrganization' );
	if ( !VueCookieNext.getCookie( 'token' )) {
		window.location.href = redirectTo ?? '/login';
	} else {
		console.log( 'token未清除' );
	}
}
const $readFileBase64 = ( file ) => new Promise(( resolve, reject ) => {
	const reader = new FileReader();
	reader.onload = () => {
		resolve( reader.result );
	};
	reader.onerror = reject;
	reader.readAsDataURL( file );
});

const $getBlobByUrl = ( url ) => new Promise(( resolve, reject ) => {
	const xhr = new XMLHttpRequest();
	xhr.open( 'get', url, true );
	xhr.responseType = 'blob';
	xhr.onload = function () {
		if ( this.status === 200 ) {
			resolve( this.response );
		} else {
			reject( new Error( 'getBlobByUrl: network is error' ));
		}
	};
	xhr.send();
	xhr.onerror = () => {
		reject( new Error( 'getBlobByUrl: url is error' ));
	};
});

/**
 * 获取图片制定宽度和高度的缩略图，仅支持aliyun的oss储存的图片
 * 针对aws的服务图片，缩略图暂时用100尺寸的图片
 * @param {图片对像} imgObj
 * @param {缩放之后的宽度} width
 * @param {缩放之后的高度} height
 * @returns
 */
const $ossImageByWidthAndHeight = ( imgObj, upCloud ) => {
	let cdnUrl = '';
	if ( !imgObj || !imgObj.bucket ) {
		return cdnUrl;
	}
	const w = imgObj.w || 100;
	const h = imgObj.h;
	const m = imgObj.m;
	const cdnUrlConfig = _get( store.state, 'global.cdnUrl', {});
	const cloud = upCloud || _get( store.state, 'global.cloud', 'aliyun' );
	if ( cloud === 'aliyun' ) {
		cdnUrl =
			cdnUrlConfig[ imgObj.bucket ] +
			imgObj.dfsID +
			`?x-oss-process=image/resize${m ? ',m_' + m : ''},w_${w}${
				h ? ',h_' + h : ''
			}`;
	} else if ( cloud === 'aws' ) {
		// 暂时用固定的尺寸，待后续调研
		cdnUrl = cdnUrlConfig[ imgObj.bucket ] + imgObj.w + 'xAUTO/' + imgObj.dfsID;
	}
	return cdnUrl;
};

// 获取国家码初始值
function $getPhoneArea( sd ) {
	if ( store.state.countryList && Array.isArray( store.state.countryList )) {
		console.log( '%c [ store.state.countryList ]-236', 'font-size:13px; background:pink; color:#bf2c9f;', store.state.countryList );
		const PhoneArea = store.state.countryList.find(( val ) => val.id === ( sd || cc ));
		return PhoneArea ? PhoneArea.phone : '86';
	} else {
		return '86';
	}
}

const $getTimeHMS = ( second ) => {
	// 转换为式分秒
	let h = 0;
	let m = 0;
	let s = 0;
	if ( Number( second ) > -1 ){
		const hour = Math.floor( Number( second ) / 3600 );
		const min = Math.floor( Number( second ) / 60 ) % 60;
		const sec = parseInt( Number( second ) % 60 );
		h = hour < 10 && hour !== 0 ? '0' + hour : hour;
		m = min < 10 && min !== 0 ? '0' + min : min;
		s = sec < 10 && sec !== 0 ? '0' + sec : sec;
	}
	return { h, m, s };
};

/**
 * 隐私政策更新校验
 * @param {*} status 是否校验在登录页
 * @returns
 */
function $privacyUpdate( status = true ) {
	const notPutList = ['/', '/login', '/activation'];
	const isLogin = notPutList.includes( _get( window, 'location.pathname' ));
	// 登录页不提示
	if ( isLogin && status ) {
		return;
	}
	const { agreedInfo } = $getLocalStorage( 'userInfo' );
	privacyUpdate({
		productKey: 'opencloud',
		agreedInfo,
		bgImg: $importImg( 'privacyUpdateBg.png' ),
		callback: ( flag ) => {
			if ( !flag ) {
				$logout();
			}
		},
	});
}

const $decodeHtml = ( html ) => {
	let s = html;
	const HTML_DECODE = {
		'&lt;': '<',
		'&gt;': '>',
		'&amp;': '&',
		'&nbsp;': ' ',
		'&quot;': '"',
		'&copy;': ''

		// Add more
	};
	const REGX_HTML_DECODE = /&\w+;|&#(\d+);/g;

	s = s !== undefined ? s : '';
	if ( s === '' ) {
		return s;
	}
	return typeof s !== 'string' ? s : s.replace(
		REGX_HTML_DECODE,
		function( $0, $1 ){
			let c = HTML_DECODE[ $0 ];
			if ( c === undefined ){
				// Maybe is Entity Number
				if ( !isNaN( $1 )){
					c = String.fromCharCode( $1 === 160 ? 32 : $1 );
				} else {
					c = $0;
				}
			}
			return c;
		}
	);
};

export {
	$checkPerm,
	$convertUTCDateToLocalDate,
	$doLang,
	$factoryList,
	$formErr,
	$getBlobByUrl,
	$getCdnUrl,
	$getCountry,
	$getFactoryList,
	$getInfo,
	$getLocalStorage,
	$getPermList,
	$getPhoneArea,
	$getSettingList,
	$getTimeHMS,
	$hasOnePerm,
	$lang,
	$logout,
	$ossImageByWidthAndHeight,
	$rdoLang,
	$readFileBase64,
	$removeLocalStorage,
	$setFactory,
	$setLang,
	$setLocalStorage,
	$privacyUpdate,
	$importImg,
	$decodeHtml,
};

